var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useDispatch } from "react-redux";
import { formattedDate, formattedDateWithTime } from "../../../utils/date";
import { downloadReports } from "../../../fnx/reportsDowload";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { quoteAll, quoteAllClearData, quoteOne, } from "../../../store/generateQuote/actions";
import { policyCancel } from "../../../store/policy/actions";
import { cancelQuote } from "../../../store/cancelQuote/actions";
var useInsurancePoliciesSummary = function (setIdCatalogStatusQuote, setDateStart, setDateEnd, clientId, enable, page, limit, nameSearch, setIsLoading, idCatalogStatusQuote, dateStart, dateEnd, fields, labelFields, setSeeToast, setBranchesOptions, showToastSuccessMessage, setNameSearch, setSelectedBranches, setSelectedProjects, setPage, fetchQuotes, setInsuranceOptions, setStatusOptions, setRows, responseInsurance, localStorageService, navigate, Steps, setModalTitle, setPolicyId, setType, setOpenModal, setRow, setOpenModalConfirm, type, policyId, activatePolicy) {
    var dispatch = useDispatch();
    var handleCancelPolicy = function (reasonId) {
        setOpenModalConfirm(false);
        setOpenModal(false);
        //get current date and time
        var currentDateAndTime = new Date();
        var currentDate = currentDateAndTime.toISOString();
        if (type) {
            var dataSubmit = {
                data: {
                    date: currentDate,
                    userId: "d2bd577e-c8c6-4519-b30a-b8e674c42952",
                    policyId: policyId,
                    catalogReasonCancellation: reasonId,
                },
            };
            dispatch(policyCancel(__assign({}, dataSubmit)));
        }
        else {
            dispatch(cancelQuote({
                id: policyId,
            }));
        }
    };
    var filterStatus = function (item) {
        var _a, _b, _c;
        var idStatus = (_a = item === null || item === void 0 ? void 0 : item.state) === null || _a === void 0 ? void 0 : _a.map(function (item) { return item.id; }).join(",");
        var idBranch = (_b = item === null || item === void 0 ? void 0 : item.branchs) === null || _b === void 0 ? void 0 : _b.map(function (item) { return item.id; }).join(",");
        var idInsurance = (_c = item === null || item === void 0 ? void 0 : item.insurance) === null || _c === void 0 ? void 0 : _c.map(function (item) { return item.id; }).join(",");
        setIdCatalogStatusQuote(idStatus);
        var isValidDateRange = Array.isArray(item === null || item === void 0 ? void 0 : item.dateRange) && item.dateRange.length > 0;
        var getFormattedDate = function (index) {
            var _a;
            if (!isValidDateRange)
                return "";
            var formattedDate = formattedDateWithTime((_a = item === null || item === void 0 ? void 0 : item.dateRange) === null || _a === void 0 ? void 0 : _a[index]);
            return formattedDate === "undefined" ||
                formattedDate === "null" ||
                formattedDate === "NA"
                ? ""
                : formattedDate;
        };
        var startDate = getFormattedDate(0);
        var endDate = getFormattedDate(1);
        setDateStart(startDate);
        setDateEnd(endDate);
        setSelectedBranches(idBranch || "");
        setSelectedProjects(idInsurance || "");
        var shouldResetPage = page !== 1;
        if (shouldResetPage) {
            setPage(1);
        }
        else {
            fetchQuotes({
                statuses: idStatus,
                creationDateStart: startDate,
                creationDateEnd: endDate,
                branches: idBranch,
                projectIds: idInsurance,
            });
        }
    };
    var onClickDownload = function (item) {
        setIsLoading(true);
        downloadReports(item, clientId, enable, page, limit, idCatalogStatusQuote, dateStart, dateEnd, fields, labelFields)
            .then(function () {
            showToastSuccessMessage("Archivo descargado con éxito", typeAlert.success, setSeeToast);
        })
            .catch(function (error) {
            showToastSuccessMessage("Ocurrio un error al descargar el archivo", typeAlert.error, setSeeToast);
        })
            .finally(function () {
            setIsLoading(false);
        });
    };
    var getQuoteAll = function () {
        fetchQuotes();
    };
    var getQuoteStatus = function (statusId) {
        dispatch(quoteAll({
            clientId: clientId,
            statuses: statusId,
            creationDateStart: null,
            creationDateEnd: null,
            enable: enable,
            page: page,
            limit: limit,
            search: nameSearch,
        }));
    };
    var searchFilter = function (term) {
        setNameSearch(term);
    };
    var onCloseSearch = function () {
        setNameSearch("");
        fetchQuotes({ search: "" });
    };
    var setBranchesOptionsStorybook = function (responseBranches) {
        var dataBranches = [];
        responseBranches === null || responseBranches === void 0 ? void 0 : responseBranches.map(function (item) {
            if (item.id && item.name) {
                dataBranches.push({
                    id: item.id,
                    name: item.name,
                    active: false,
                });
            }
        });
        setBranchesOptions(dataBranches);
    };
    var setInsuranceOptionsStorybook = function (responseProject) {
        var dataInsurance = [];
        responseProject === null || responseProject === void 0 ? void 0 : responseProject.map(function (item) {
            if (item.id && item.description) {
                dataInsurance.push({
                    id: item.id,
                    name: item.description,
                    active: false,
                    src: item.logoUrl,
                });
            }
        });
        setInsuranceOptions(dataInsurance);
    };
    var setStatusOptionsStorybook = function (responseGetCatalogStatusQuote) {
        var dataStatus = [];
        responseGetCatalogStatusQuote === null || responseGetCatalogStatusQuote === void 0 ? void 0 : responseGetCatalogStatusQuote.map(function (item) {
            if (item.id && item.description) {
                dataStatus.push({
                    id: item.id,
                    name: item.description,
                    active: false,
                });
            }
        });
        setStatusOptions(dataStatus);
    };
    var setDataQuoteStorybook = function (responseAllQuote) {
        var dataR = responseAllQuote === null || responseAllQuote === void 0 ? void 0 : responseAllQuote.map(function (item) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
            return ({
                id: item === null || item === void 0 ? void 0 : item.id,
                quotation: item === null || item === void 0 ? void 0 : item.code,
                quoteDate: (item === null || item === void 0 ? void 0 : item.creationDate) && formattedDate(item === null || item === void 0 ? void 0 : item.creationDate),
                issueDate: ((_a = item === null || item === void 0 ? void 0 : item.policyId) === null || _a === void 0 ? void 0 : _a.effectiveFrom) &&
                    formattedDate((_b = item === null || item === void 0 ? void 0 : item.policyId) === null || _b === void 0 ? void 0 : _b.effectiveFrom),
                certificate: (item === null || item === void 0 ? void 0 : item.policyId) && ((_c = item === null || item === void 0 ? void 0 : item.policyId) === null || _c === void 0 ? void 0 : _c.code),
                identification: item === null || item === void 0 ? void 0 : item.numberId,
                firstNameA: "".concat(item === null || item === void 0 ? void 0 : item.firstNameA, " ").concat(item === null || item === void 0 ? void 0 : item.firstNameB),
                lastNameA: item === null || item === void 0 ? void 0 : item.lastNameA,
                lastNameB: item === null || item === void 0 ? void 0 : item.lastNameB,
                status: (_e = (_d = item === null || item === void 0 ? void 0 : item.catalogPolicyStatus) === null || _d === void 0 ? void 0 : _d.description) !== null && _e !== void 0 ? _e : (_f = item === null || item === void 0 ? void 0 : item.catalogStatusQuote) === null || _f === void 0 ? void 0 : _f.description,
                branch: (_g = item === null || item === void 0 ? void 0 : item.branchData) === null || _g === void 0 ? void 0 : _g.name,
                user: (_h = item === null || item === void 0 ? void 0 : item.user) === null || _h === void 0 ? void 0 : _h.fullName,
                product: (_j = item === null || item === void 0 ? void 0 : item.productId) === null || _j === void 0 ? void 0 : _j.description,
                code: (_k = item === null || item === void 0 ? void 0 : item.productId) === null || _k === void 0 ? void 0 : _k.code,
                insuranceCarrier: (_l = item === null || item === void 0 ? void 0 : item.sponsor) === null || _l === void 0 ? void 0 : _l.name,
                cancellationDate: ((_m = item === null || item === void 0 ? void 0 : item.catalogCancellation) === null || _m === void 0 ? void 0 : _m.createdAt) &&
                    formattedDate((_o = item === null || item === void 0 ? void 0 : item.catalogCancellation) === null || _o === void 0 ? void 0 : _o.createdAt),
                reasonCancellation: (_p = item === null || item === void 0 ? void 0 : item.catalogCancellation) === null || _p === void 0 ? void 0 : _p.description,
                policyId: (_q = item === null || item === void 0 ? void 0 : item.policyId) === null || _q === void 0 ? void 0 : _q.id,
                brandVehicle: "",
                modelVehicle: "",
                productId: (_r = item === null || item === void 0 ? void 0 : item.productId) === null || _r === void 0 ? void 0 : _r.id,
                productCode: (_s = item === null || item === void 0 ? void 0 : item.productId) === null || _s === void 0 ? void 0 : _s.code,
                // brandVehicle: item.contentMap.fkCatalogBrandVeh.value,
                // modelVehicle: item.contentMap.fkCatalogModelVeh.value,
            });
        });
        setRows(dataR);
        dispatch(quoteAllClearData());
    };
    var filterData = function (array, key, value) {
        var temp = [];
        temp = array.filter(function (e) {
            return e[key] == value;
        });
        var result = [];
        temp.map(function (item) {
            result.push({ id: item.id, value: item.id, name: item.description });
        });
        return result;
    };
    var setLocalStorage = function (params) {
        var product = params.row.product.replace(/\s+/g, "");
        switch (product) {
            case "AutoFull":
                // localStorageService.setStepStored({
                //   id: "",
                //   name: "",
                //   step: Steps.insurance,
                //   completed: true,
                //   campaign: responseInsurance[0].campaign,
                //   flow: responseInsurance[0].salesFlow,
                // });
                // localStorageService.setStepStored({
                //   id: "",
                //   name: "",
                //   step: Steps.customer,
                //   completed: true,
                //   quoteId: params.row.id,
                //   campaign: "",
                //   coverType: { id: "", name: "" },
                //   paymentModeSelected: { id: "", name: "" },
                //   campaignSelected: { id: "", name: "" },
                // });
                break;
            default:
                break;
        }
    };
    var handleClickContextMenu = function (item, params) {
        switch (item.id) {
            case "1":
                handleDelete(params);
                break;
            case "2":
                if (params.row.status === "Cotizada" ||
                    params.row.status === "cotizada") {
                    navigate("/confirmationForm/".concat(params.row.id, "/true/false/").concat(params.row.productId));
                }
                else {
                    navigate("/confirmationForm/".concat(params.row.id, "/false/false/").concat(params.row.productId));
                }
                break;
            case "3":
                setLocalStorage(params);
                if (params.row.code === "ALE") {
                    showToastSuccessMessage("Operación no permitida!", typeAlert.warning, setSeeToast);
                }
                else {
                    navigate("/fiscalizacion-apap-auto/" + params.row.id);
                }
                break;
            case "4":
                callQuoteOne(params.row.id);
                break;
            case "5":
                // activatePolicy(params.row.policyId || "");
                navigate("/confirmationForm/".concat(params.row.id, "/false/false/").concat(params.row.productId));
                break;
            default:
                break;
        }
    };
    var handleDelete = function (event) {
        if (event.row.policyId !== undefined) {
            console.log("Es una póliza");
            setModalTitle("póliza");
            setPolicyId(event.row.policyId);
            setType(true);
        }
        else {
            console.log("Es una cotización");
            setModalTitle("cotización");
            setPolicyId(event.row.id);
            setType(false);
        }
        setRow(event.row);
        setOpenModal(true);
    };
    var callQuoteOne = function (quoteId) {
        if (quoteId !== "") {
            dispatch(quoteOne({
                id: quoteId,
                log: true,
            }));
        }
    };
    return {
        filterStatus: filterStatus,
        onClickDownload: onClickDownload,
        getQuoteAll: getQuoteAll,
        searchFilter: searchFilter,
        onCloseSearch: onCloseSearch,
        setBranchesOptionsStorybook: setBranchesOptionsStorybook,
        setInsuranceOptionsStorybook: setInsuranceOptionsStorybook,
        setStatusOptionsStorybook: setStatusOptionsStorybook,
        setDataQuoteStorybook: setDataQuoteStorybook,
        filterData: filterData,
        setLocalStorage: setLocalStorage,
        handleClickContextMenu: handleClickContextMenu,
        handleDelete: handleDelete,
        callQuoteOne: callQuoteOne,
        handleCancelPolicy: handleCancelPolicy,
        getQuoteStatus: getQuoteStatus,
    };
};
export default useInsurancePoliciesSummary;
